const Ok200 = 200;
const Created201 = 201;
const Accepted202 = 202;
const NoContent204 = 204;
const BadRequest400 = 400;
const Unauthorized401 = 401;
const Forbidden403 = 403;
const NotFount404 = 404;
const ServerError500 = 500;

export const statusCode = {
  Ok200,
  Created201,
  Accepted202,
  NoContent204,
  BadRequest400,
  Unauthorized401,
  Forbidden403,
  NotFount404,
  ServerError500,
};
